/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */
export enum ReservationStatusCode {
  RESERVED = <any>'R',
  CHECKED_IN = <any>'I',
  CHECKED_OUT = <any>'O',
  CANCELLED = <any>'C',
  NO_SHOW = <any>'N',
  RSVP = <any>'RSVP'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/reservation-status-code.enum.ts